













import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import { WxBaseWidget } from '../wxBaseWidget';

@Component({ name: 'wxTextWidget' })
export default class WxTextWidget extends WxBaseWidget {
    public get text() {
        return this.item[this.fieldName] || this.item[this.fieldName] === 0 ? String(this.item[this.fieldName]) : '';
    }

    public set text(value: string) {
        this.item[this.fieldName] = value && !(value.trim().length === 0) ? value : null;
        this.$emit('input', value && !(value.trim().length === 0) ? value : null);
    }
}
